var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.643066C3 0.366924 3.22386 0.143066 3.5 0.143066H7.5C7.77614 0.143066 8 0.366924 8 0.643066C8 0.919209 7.77614 1.14307 7.5 1.14307H3.5C3.22386 1.14307 3 0.919209 3 0.643066Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.9764C0.723858 1.9764 0.5 2.20026 0.5 2.4764C0.5 2.75254 0.723858 2.9764 1 2.9764H1.83333V8.30973C1.83333 9.32226 2.65414 10.1431 3.66667 10.1431H7.33333C8.34586 10.1431 9.16667 9.32226 9.16667 8.30973V2.9764H10C10.2761 2.9764 10.5 2.75254 10.5 2.4764C10.5 2.20026 10.2761 1.9764 10 1.9764H1ZM4.5 4.30973C4.77614 4.30973 5 4.53359 5 4.80973V7.30973C5 7.58588 4.77614 7.80973 4.5 7.80973C4.22386 7.80973 4 7.58588 4 7.30973V4.80973C4 4.53359 4.22386 4.30973 4.5 4.30973ZM6.5 4.30973C6.77614 4.30973 7 4.53359 7 4.80973V7.30973C7 7.58588 6.77614 7.80973 6.5 7.80973C6.22386 7.80973 6 7.58588 6 7.30973V4.80973C6 4.53359 6.22386 4.30973 6.5 4.30973Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveB);
export default __webpack_public_path__ + "static/media/removeB.7449311a.svg";
export { ForwardRef as ReactComponent };